import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/img/logo.jpg'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "header-left d-flex align-items-center" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "site-title" }
const _hoisted_7 = ["title", "aria-label"]
const _hoisted_8 = { class: "menu ri-menu-line" }
const _hoisted_9 = { class: "close ri-close-line" }
const _hoisted_10 = { class: "header-right" }
const _hoisted_11 = { class: "header-core-actions" }
const _hoisted_12 = {
  key: 0,
  class: "option-item dropdown"
}
const _hoisted_13 = {
  type: "button",
  class: "header-utility-button header-screen-toggle dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_14 = { class: "dropdown-menu dropdown-menu-end header-screen-menu border-0 shadow-sm" }
const _hoisted_15 = { class: "ps-2" }
const _hoisted_16 = { class: "ps-2" }
const _hoisted_17 = { class: "ps-2" }
const _hoisted_18 = {
  key: 1,
  class: "option-item"
}
const _hoisted_19 = {
  key: 0,
  type: "button",
  class: "header-utility-button header-register-button is-danger",
  "data-bs-toggle": "modal",
  "data-bs-target": "#closeRegisterModal"
}
const _hoisted_20 = {
  key: 1,
  type: "button",
  class: "header-utility-button header-register-button is-success",
  "data-bs-toggle": "modal",
  "data-bs-target": "#openRegisterModal"
}
const _hoisted_21 = {
  key: 2,
  class: "option-item"
}
const _hoisted_22 = { class: "option-item" }
const _hoisted_23 = { class: "option-item" }
const _hoisted_24 = { class: "option-item" }
const _hoisted_25 = { class: "option-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ToggleFullscreenBtn = _resolveComponent("ToggleFullscreenBtn")!
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_ProfileDropdown = _resolveComponent("ProfileDropdown")!
  const _component_SettingsBarBtn = _resolveComponent("SettingsBarBtn")!

  return (_openBlock(), _createElementBlock("div", {
    id: "header",
    class: _normalizeClass(["header-area style-two bg-white w-100", { 'is-pos-header': _ctx.isPosPage }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(
            _ctx.isPosPage
              ? 'col-xl-4 col-lg-5 col-md-5 col-sm-4'
              : 'col-xl-6 col-lg-5 col-md-5 col-sm-4'
          )
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "logo"
            }, {
              default: _withCtx(() => [
                (_ctx.stateStore.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "logo-light logo-custom",
                      src: _ctx.getLogoUrl(_ctx.stateStore.logo),
                      alt: _ctx.$t('header.logo_alt')
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "logo-light logo-custom",
                      src: _imports_0,
                      alt: _ctx.$t('header.default_logo_alt')
                    }, null, 8, _hoisted_5))
              ]),
              _: 1
            }),
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.stateStore.siteName), 1),
            _createElementVNode("button", {
              class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
              id: "header-burger-menu",
              title: _ctx.$t('header.toggle_sidebar'),
              "aria-label": _ctx.$t('header.toggle_sidebar'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleBurgerMenu && _ctx.toggleBurgerMenu(...args)))
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [
                [_vShow, _ctx.showOpenBtn]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                [_vShow, _ctx.showCloseBtn]
              ])
            ], 8, _hoisted_7)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(
            _ctx.isPosPage
              ? 'col-xl-8 col-lg-7 col-md-7 col-sm-8'
              : 'col-xl-6 col-lg-7 col-md-7 col-sm-8'
          )
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.isPosPage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("button", _hoisted_13, [
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-layout-grid-line" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.screens")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item header-screen-menu-item",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCustomerDisplay && _ctx.openCustomerDisplay(...args)))
                      }, [
                        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-cast-line" }, null, -1)),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("pos.customer_screen")), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item header-screen-menu-item",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPickupDisplay && _ctx.openPickupDisplay(...args)))
                      }, [
                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-notification-3-line" }, null, -1)),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("pos.pickup_screen")), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item header-screen-menu-item",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openQueuePage && _ctx.openQueuePage(...args)))
                      }, [
                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-ticket-2-line" }, null, -1)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("pos.waiting_queue")), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isPosPage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_ctx.stateStore.registerStatus.isOpen)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_19, [
                          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "ri-shut-down-line" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.close_register")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("button", _hoisted_20, [
                          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ri-door-open-line" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.open_register")), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isPosPage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_router_link, {
                      to: "/pos",
                      class: "pos-link rounded-1 d-inline-block lh-1 fw-semibold transition"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("pos_screen")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_ToggleFullscreenBtn)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_LanguageDropdown)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_ProfileDropdown)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_SettingsBarBtn)
              ])
            ])
          ])
        ], 2)
      ])
    ])
  ], 2))
}